module.exports = {
  apiHost: "https://api.riverlea.sensoreal.com.au",
  assetsHost: "https://assets.riverlea.sensoreal.com.au",
  contact: {
    address: "",
    email: "info@riverlea.com.au",
    phone: "",
    website: "https://www.riverlea.com.au",
  },
  formTemplate: "walker",
  header: {
    logo: "https://assets.riverlea.sensoreal.com.au/misc/riverlea-logo.png",
    text: {
      en: "Your Riverlea Selections",
      ar: "",
    },
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  links: {
    instagram: "",
    facebook: "https://www.facebook.com/riverlea.sa/",
    linkedin: "",
    privacy:
      "https://www.walkercorp.com.au/about/privacy/?site=www.riverlea.com.au",
    twitter: "",
    youtube: "",
  },
  style: {
    primaryColor: "#111f25",
    textColor: "#fff",
  },
};
